export const sxSelect = {
    // border: '1px solid yellow',
    background: '#D9D9D9',
    boxShadow: 'none',
    '.MuiOutlinedInput-notchedOutline': { border: 'none' },
    fontWeight: 400,
    fontSize: '14px',
    width: '100%',
    height: '30px',
    padding: '0 3px',
    '& .MuiSelect-icon': {
        color: '#929292'
    }
}

export const sxMenuPaper = {
    border: '1px solid #8a05be',
    // width: '90%',
    maxWidth: '500px',
    // height: 'calc(100% - 116px)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
}
